module.exports = __webpack_public_path__ + "static/media/CentraNo2-Light.ca437433.woff2";